import React from "react"
import useFetch from "../../../hooks/useFetch"
import { api } from "../../../services/api"
import { CharacterFace } from "./Character"
import WordImageMatching from "./WordImageMatching"

function Game(props) {
  const [show, setShow] = React.useState(false)
  React.useEffect(() => {
    setShow(true)
  }, [])
  const className = `position-fixed p-3 w-100 d-flex justify-content-center fade ${
    show ? "show" : ""
  }`

  const { url, opt } = React.useMemo(
    () =>
      api.games.About.Generate({
        starting_letter: props.letter,
      }),
    [props.letter]
  )

  const [data, isPending, error] = useFetch({ url, opt })

  return (
    <div
      className={className}
      style={{
        zIndex: 1,
        backgroundColor: "rgba(242, 192, 97)",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
      }}
    >
      <div className="d-flex align-items-center w-100 gap-1">
        <div
          className="rounded-circle p-4 border border-light border-4 shadow position-relative"
          style={{
            backgroundColor: props.colors?.shirt ?? "rgb(16, 101, 234)",
          }}
        >
          <CharacterFace {...props.colors} />
          <p
            className="position-absolute bottom-0 start-50 m-0 px-2 py-1 bg-body rounded text-center text-white"
            style={{
              transform: "translate(-50%,calc(100% + 10px))",
            }}
          >
            {props.name.split(" ")[0]}
          </p>
        </div>

        <div
          className="d-flex align-items-center w-100"
          style={{
            maxWidth: 800,
          }}
        >
          <div className="triangle bg-light" />
          {isPending ? (
            "Loading game..."
          ) : error ? (
            "Error loading game"
          ) : (
            <WordImageMatching
              onCancel={props.onCancel}
              onCompleted={props.onCompleted}
              letter={props.letter}
              gameConfig={data}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Game
